import { render, staticRenderFns } from "./ReceiveOrderList.vue?vue&type=template&id=40d2956a&scoped=true"
import script from "./ReceiveOrderList.vue?vue&type=script&lang=js"
export * from "./ReceiveOrderList.vue?vue&type=script&lang=js"
import style0 from "./ReceiveOrderList.vue?vue&type=style&index=0&id=40d2956a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2956a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d2956a')) {
      api.createRecord('40d2956a', component.options)
    } else {
      api.reload('40d2956a', component.options)
    }
    module.hot.accept("./ReceiveOrderList.vue?vue&type=template&id=40d2956a&scoped=true", function () {
      api.rerender('40d2956a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/pay/ReceiveOrderList.vue"
export default component.exports